import Grid from '@mui/material/Unstable_Grid2';
import Box from '@mui/material/Box/Box';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment/InputAdornment';
import Button from '@mui/material/Button/Button';
import SearchIcon from '@mui/icons-material/Search';
import { Dayjs } from 'dayjs';
import { useEffect, useState } from 'react';
import { DateRangePicker } from './daterangepicker';
import { filterStyle } from '../../styles/common/filter';

// export function Filter({ setSearchResult }: SearchBarProps){
export function Filter(props: { placeholder: any; onSearchChange: (searchTerm: string) => void; onSearchClick: () => void; startDate: (startDate: Dayjs | null) => void; endDate: (endDate: Dayjs | null) => void; }){

  const handleSearchChange = (event) => {
    const searchTerm = event.target.value;
    props?.onSearchChange(searchTerm);
  };

  const handleSearchClick = () => {
    props?.onSearchClick();
  }

  return (
  <>
    <Grid xs>
      <TextField sx={filterStyle.contentBoxTextField}
        placeholder={props?.placeholder || "Search"}
        variant="outlined"
        size="small"
        onChange={handleSearchChange}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
        }}
      />
    </Grid>
    <Grid xs="auto">
      <DateRangePicker startDate={(startDate) => props?.startDate(startDate)} endDate={(endDate) => props?.endDate(endDate)} />
    </Grid> 
    <Grid xs="auto">
      <Button variant="contained" color="primary" onClick={handleSearchClick}>Search / Filter</Button>
    </Grid>
  </>
  // <Box sx={filterStyle.contentBox}>
  //   <TextField sx={filterStyle.contentBoxTextField}
  //     error
  //     placeholder="Search"
  //     variant="outlined"
  //     size="small"
  //     // value={searchTerm}
  //     onChange={handleSearchChange}
  //     // onKeyPress={handleKeyPress}
  //     InputProps={{
  //       startAdornment: (
  //         <InputAdornment position="start">
  //           <SearchIcon />
  //         </InputAdornment>
  //       ),
  //     }}
  //   />
  //   <DateRangePicker/>
  //   <Button variant="contained" color="primary" onClick={handleSearch}>Search / Filter</Button>
  // </Box>
  );
};
